import { render, staticRenderFns } from "./trade-statistics-column-chart.vue?vue&type=template&id=63bebbe4&"
import script from "./trade-statistics-column-chart.vue?vue&type=script&lang=js&"
export * from "./trade-statistics-column-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports